<template>
  <div>
    <el-dialog :title="'新增' + typeStr + '明细'" :visible.sync="isPaymentShow" width="85%" class="handlePlan" @close="closeDialog">
      <div class="bg-f3f4f7 flex text-left plr-20 ptb-10 align-center">
        <div class="flex-1 mr-40">
          <!--<div class="font-12-30313a"><span class="font-12-b9b9b9">{{type === 2 ? '收款': type === 1 ? '付款':'提成'}}单号：</span>20190829417005</div>-->
          <div class="font-12-30313a flex align-center"><span class="font-12-b9b9b9">纸质单号：</span><el-input placeholder="请输入" class="flex-1" v-model="writingNumber"></el-input></div>
        </div>
        <div class="flex-1 mr-40">
          <!--<div class="font-12-30313a"><span class="font-12-b9b9b9">收款人员：</span>20190829417005</div>-->
          <div class="font-12-30313a flex align-center"><span class="font-12-b9b9b9">{{typeStr}}账号：</span>
            <!-- <el-select class="flex-1" v-model="ways" placeholder="请选择" @change="selectAccount">
              <el-option v-for="(item, index) in optionList" :key="index" :label="item.name"  :value="item.id+','+item.name"></el-option>
            </el-select> -->
            <el-select v-model="ways" placeholder="请选择" @change="selectAccount">
              <div v-for="(item, index) in optionList" :key="index">
                <template v-if="item.children">
                  <el-option-group
                    :key="item.id"
                    :label="item.name">
                    <el-option
                      v-for="itemcell in item.children"
                      :key="itemcell.id"
                      :label="itemcell.name"
                      :value="itemcell.id">
                    </el-option>
                  </el-option-group>
                </template>
                <template v-else>
                  <div>
                    <el-option :label="item.name"  :value="item.id"></el-option>
                  </div>
                </template>
              </div>
            </el-select>
          </div>
        </div>
        <div class="flex-2">
          <!--<div class="font-12-30313a flex">-->
          <!--<div class="flex"><span class="font-12-b9b9b9">客户信息：</span>张丰毅/15984525554/新怡华庭13栋2301</div>-->
          <!--<div class="flex flex-1 justify-end"><span class="font-12-b9b9b9">开单时间：</span>2019.08.29 14:35</div>-->
          <!--</div>-->
          <div class="font-12-30313a flex align-center"><span class="font-12-b9b9b9">单号备注：</span><el-input placeholder="请输入" class="flex-1" v-model="description"></el-input></div>
        </div>
      </div>
      <div class="plr-20 ptb-10" style="height: 400px">
        <div class="flex">
          <div class="flex align-center mr-5 mb-5 btn-24-bd-30313a" @click="addPaymentType">
            <img src="/static/images/add.png" class="icon-14 mr-5" alt="">
            <div>新增款项</div>
          </div>
        </div>
        <div style="height: 360px">
          <erp-table ref="erpTable" :table-data="tableArray" :is-edit="true" @on-modify="onModify" modify-method="on-modify" :column-data="tableArray1" @on-delete1="onDelete1" :table-footer="tableFooter1"></erp-table>
        </div>
      </div>
      <div slot="footer">
        <button class="btn-30-bg-f5971d-s" @click="subPaymentOrder" :disabled="lockLoading">保存</button>
      </div>
    </el-dialog>
    <!--添加款项-->
    <el-dialog title="添加款项" :visible.sync="paymentTypeDialog"   width="568px" class="handlePlan">
      <div style="height: 560px">
        <el-scrollbar class="h-100 hide-x">
          <div class="h-100 flex-column">
            <div class="plr-20 ptb-10">
              <div class="flex-column mb-20">
                <div class=" flex mb-5"><button class="btn-20-bg-3d3e46">未清款项</button></div>
                <div class="flex-column w-100 mb-10">
                  <div style="height: 300px">
                    <erp-table ref="erpTable1" :table-data="undoFunds"  :column-data="fundList0"></erp-table>
                  </div>
                </div>
                <div class="font-12-b9b9b9 ptb-8 text-left" v-if="undoFunds.length===0">此客户暂无未请款项</div>
                <div v-if="noneShow" style="visibility: hidden"></div>
              </div>
              <div class="flex-column mb-20">
                <div class=" flex"><button class="btn-20-bg-3d3e46">已审核款项</button></div>
                <div class="flex-column w-100 mb-10" v-for="(item,index) in auditFunds" :key="index" v-if="auditFunds.length>0">
                  <div class="flex mb-10">
                    <div class="flex align-center cursor" @click="selectIsMaterial2(index, 2, auditFunds)">
                      <img class="mr-5" :src="item.selected ? '/static/images/customer/xuanzhong.png' : '/static/images/customer/weixuan.png'" alt="">
                      <div class="font-12-ff5555">添加{{item.name}}</div>
                    </div>
                    <div class="flex flex-1 justify-end">
                      <div class="flex align-center btn-24-bd-e2-bg-ff" @click="calc(0, index)">
                        <img src="/static/images/shuaxin.png" class="icon-14 mr-5" alt="">
                        <div>计算刷新</div>
                      </div>
                    </div>
                  </div>
                  <div style="max-height: 100px">
                    <erp-table ref="billTable" @on-modify="onModifyBill" modify-method="on-modify" :table-data="item.billItemTemplateList" :is-edit="isEdit" :column-data="fundList"></erp-table>
                  </div>
                </div>
                <div class="font-12-b9b9b9 ptb-8 text-left" v-if="auditFunds.length===0">此客户暂无已审核款项</div>
                <div v-if="noneShow" style="visibility: hidden"></div>
              </div>
              <div class="flex-column mb-20">
                <div class=" flex"><button class="btn-20-bg-3d3e46">新收款项</button></div>
                <div class="flex-column w-100 mb-10" v-for="(item,index) in newFunds" :key="index" v-if="newFunds.length>0">
                  <div class="flex mb-10">
                    <div class="flex align-center cursor" @click="selectIsMaterial3(index, 3, newFunds)">
                      <img class="mr-5" :src="item.selected ? '/static/images/customer/xuanzhong.png' : '/static/images/customer/weixuan.png'" alt="">
                      <div class="font-12-ff5555">添加{{item.name}}</div>
                    </div>
                    <div class="flex flex-1 justify-end">
                      <div class="flex align-center btn-24-bd-e2-bg-ff" @click="calc(1, index)">
                        <img src="/static/images/shuaxin.png" class="icon-14 mr-5" alt="">
                        <div>计算刷新</div>
                      </div>
                    </div>
                  </div>
                  <div style="height: 100px">
                    <erp-table :is-edit="true" ref="billTable1" @on-modify="onModifyBill" modify-method="on-modify" :table-data="item.billItemTemplateList" :column-data="fundList"></erp-table>
                  </div>
                </div>
                <div class="font-12-b9b9b9 ptb-8 text-left" v-if="newFunds.length===0">此客户暂无新收款项</div>
                <div v-if="noneShow" style="visibility: hidden"></div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div slot="footer">
        <div class="btn-30-bg-f5971d-s" @click="submit">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ErpTable from '@/components/ErpTable'
export default {
  name: 'AddDetail',
  components: {ErpTable},
  props: ['type', 'customerId', 'customerAddress'],
  data () {
    return {
      isEdit: false,
      isPaymentShow: false,
      typeStr: '收款',
      paymentTypeDialog: false,
      ways: null,
      account_id: '',
      account: '',
      array: [],
      writingNumber: '',
      description: '',
      optionList: [],
      noneShow: false,
      undoFunds: [],
      auditFunds: [],
      newFunds: [],
      fundType: null,
      fundList: [
        {
          field: 'isAccounting',
          title: '记账',
          width: '60',
          formatter: 'toYesOrNo'
        }, {
          field: 'specialItem',
          title: '代码',
          width: '80'
        }, {
          field: 'formulaCompute',
          title: '计算公式',
          width: '100'
        }, {
          field: 'fundContent',
          title: '款项内容',
          width: '166'
        }, {
          field: 'planBill',
          title: '应收金额',
          width: '120',
          editRender: {
            name: 'input'
          }
        }
      ],
      fundList0: [
        {
          type: 'selection',
          width: '40',
          fixed: 'left'
        }, {
          type: 'index',
          title: '序号',
          width: '60',
          fixed: 'left'
        }, {
          field: 'isAccounting',
          title: '记账',
          width: '60',
          formatter: 'toYesOrNo'
        }, {
          field: 'specialItem',
          title: '代码',
          width: '80'
        }, {
          field: 'formulaCompute',
          title: '计算公式',
          width: '100'
        }, {
          field: 'fundContent',
          title: '款项内容',
          width: '166'
        }, {
          field: 'planBill',
          title: '应收金额',
          width: '120'
        }, {
          field: 'realBill',
          title: '实收金额',
          width: '120'
        }
      ],
      tableFooter1: [
        {
          columns: ['planBill', 'realBill', 'undoBill'],
          type: 'sum',
          name: '合计'
        }
      ],
      tableArray: [],
      uniKey: 0,
      tableArray1: [
        {
          field: 'operate',
          title: '操作',
          width: '100',
          fixed: 'left',
          isDefine: true,
          child: [{
            type: 'btn',
            className: 'btn-16-bd-ff5555 btn-hover',
            title: '删除',
            methodName: 'on-delete1'
          }]},
        {
          type: 'index',
          title: '序号',
          width: '60',
          fixed: 'left'
        }, {
          field: 'fundContent',
          title: '款项名称',
          width: '200'
        },
        {
          field: 'planBill',
          title: '应收',
          width: '100'
        },
        {
          field: 'realBill',
          title: '实收',
          width: '120',
          // editType: 'number',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'undoBill',
          title: '未收',
          width: '100'
        }, {
          field: 'description',
          title: '说明',
          minWidth: '100',
          editRender: {
            name: 'input'
          }
        }
      ],
      lockLoading: false
    }
  },
  watch: {
    // paymentDialog (newVal, oldVal) {
    //   this.isPaymentShow = newVal
    // },
    type (newVal) {
      this.typeStr = newVal === 1 ? '付款' : newVal === 2 ? '收款' : newVal === 3 ? '提成' : '其他'
    }
  },
  created () {
    this.typeStr = this.type === 1 ? '付款' : this.type === 2 ? '收款' : this.type === 3 ? '提成' : '其他'
  },
  mounted () {
    this.getAccount()
  },
  methods: {
    selectAccount (way) {
      this.account = ''
      this.account_id = ''
      for (let i = 0; i < this.optionList.length; i++) {
        if (way === this.optionList[i].id) {
          this.account = this.optionList[i].name
          this.account_id = this.optionList[i].id
        }
        if (!this.account_id && this.optionList[i].children) {
          for (let j = 0; j < this.optionList[i].children.length; j++) {
            if (way === this.optionList[i].children[j].id) {
              this.account = this.optionList[i].children[j].name
              this.account_id = this.optionList[i].children[j].id
            }
          }
        }
      }
    },
    onModify (row, column, colName) {
      if (colName === 'realBill') {
        row.realBill = parseFloat(row[colName] || 0)
        row.undoBill = (parseFloat(row.planBill) - row.realBill).toFixed(2)
      }
      this.$refs.erpTable.updateFooter()
    },
    onModifyBill (row, column, colName) {
    },
    closeDialog () {
      this.isPaymentShow = false
      this.array = []
      this.tableArray = []
    },
    calc (type, index) {
      let funds = type === 0 ? this.auditFunds : this.newFunds
      let data = funds[index]
      data.customerId = this.customerId
      this.axios.post('financeBill/calculate', data).then(res => {
        if (res.data.success) {
          this.$message.success('刷新成功')
          for (var i = 0; i < res.data.data.billItemTemplateList.length; i++) {
            if (res.data.data.billItemTemplateList[i].isModified !== 1) {
              res.data.data.billItemTemplateList[i].unEditable = 'planBill'
            }
          }
          this.$set(type === 0 ? this.auditFunds : this.newFunds, index, res.data.data)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    subPaymentOrder () { // 提交收款单
      this.lockLoading = true
      let list = []
      let item = {}
      let dataArr = this.array.concat(this.tableArray)
      for (var i = 0; i < dataArr.length; i++) {
        item = {}
        if (dataArr[i].itemId) {
          if (dataArr[i].itemId !== undefined) {
            item.itemId = dataArr[i].itemId
          } else {
            item.itemId = null
          }
        } else {
          if (dataArr[i].id !== undefined) {
            item.billTemplateId = dataArr[i].id
          } else {
            item.billTemplateId = null
          }
        }
        if (dataArr[i].type !== undefined) {
          item.type = dataArr[i].type
        } else {
          item.type = ''
        }
        if (dataArr[i].isAccounting !== undefined) {
          item.isAccounting = dataArr[i].isAccounting
        } else {
          item.isAccounting = null
        }
        if (dataArr[i].isModified !== undefined) {
          item.isModified = dataArr[i].isModified
        } else {
          item.isModified = null
        }
        if (dataArr[i].specialItem !== undefined) {
          item.specialItem = dataArr[i].specialItem
        } else {
          item.type = ''
        }
        if (dataArr[i].fundContent !== undefined) {
          item.fundContent = dataArr[i].fundContent
        } else {
          item.fundContent = ''
        }
        if (dataArr[i].formulaCompute !== undefined) {
          item.formulaCompute = dataArr[i].formulaCompute
        } else {
          item.formulaCompute = ''
        }
        if (dataArr[i].planBill !== undefined) {
          item.planBill = dataArr[i].planBill
        } else {
          item.planBill = null
        }
        if (dataArr[i].realBill !== undefined) {
          item.realBill = dataArr[i].realBill
        } else {
          item.realBill = null
        }
        if (dataArr[i].description !== undefined) {
          item.description = dataArr[i].description
        } else {
          item.description = null
        }
        if (dataArr[i].sort !== undefined) {
          item.sort = dataArr[i].sort
        } else {
          item.sort = null
        }
        list[i] = item
      }
      if (!this.account_id) {
        this.$message({
          message: '请选择收款账号'
        })
      } else {
        this.axios.post(`${this.$store.state.API_URL_9010}/financeBill/save`, {
          companyId: this.$store.state.companyId,
          customerId: this.customerId,
          customerAddress: this.customerAddress,
          writingNumber: this.writingNumber,
          type: this.type,
          account_id: this.account_id,
          account: this.account,
          description: this.description,
          financeBillItemParamList: list
        }).then(res => {
          if (res.data.success) {
            this.$message({
              type: 'success',
              message: '提交成功！',
              duration: 1000
            })
            this.tableArray = []
            this.array = []
            this.ways = null
            this.account = ''
            this.account_id = null
            this.description = ''
            this.writingNumber = ''
            // this.isPaymentShow = false
            this.$emit('submit-bill')
          } else {
            this.$message({
              type: 'error',
              message: '提交失败！',
              duration: 1000
            })
          }
        })
      }
      setTimeout(() => {
        this.lockLoading = false
      }, 3000)
    },
    submit () { // 提交款项
      let customerArr = this.$refs.erpTable1.getSelectEvent()
      let dataArr = []
      if (customerArr.length > 0) {
        customerArr.forEach(item => {
          item.uniKey = this.uniKey++
          // this.array.push(item)
          dataArr.push(item)
        })
      }
      this.auditFunds.forEach(item => {
        if (item.selected === true) {
          item.billItemTemplateList.forEach(i => {
            i['isType'] = 1
            i.uniKey = this.uniKey++
            // this.array.push(i)
            dataArr.push(i)
          })
        }
      })
      this.newFunds.forEach(item => {
        if (item.selected === true) {
          item.billItemTemplateList.forEach(i => {
            i.uniKey = this.uniKey++
            // this.array.push(i)
            dataArr.push(i)
          })
        }
      })
      let realBill = 0
      let array = []
      let tableArray = []
      dataArr.forEach(list => {
        if (list.realBill === 'undefined') {
          list.realBill = 0
        }
        list.realBill = list.planBill
        list.undoBill = 0
        list.planBill = Number(list.planBill).toFixed(2)
        list.realBill = Number(list.realBill).toFixed(2)
        list.undoBill = Number(list.undoBill).toFixed(2)
        if (list.isAccounting === 1) {
          tableArray.push(list)
          realBill += Number(list.realBill)
        } else {
          array.push(list)
        }
      })
      if (realBill === 0 || isNaN(realBill)) {
        this.$message({
          message: '请输入应收金额'
        })
      } else {
        this.array = array
        this.tableArray = tableArray
        this.paymentTypeDialog = false
      }
    },
    selectIsMaterial2 (a, b, list) {
      this.fundType = b
      if (this.auditFunds[a].selected === true) {
        this.auditFunds[a].selected = false
        this.noneShow = !this.noneShow
      } else {
        this.auditFunds[a].selected = true
        this.noneShow = !this.noneShow
      }
    },
    selectIsMaterial3 (a, b, list) {
      this.fundType = b
      if (this.newFunds[a].selected === true) {
        this.newFunds[a].selected = false
        this.noneShow = !this.noneShow
      } else {
        this.newFunds[a].selected = true
        this.noneShow = !this.noneShow
      }
    },
    addPaymentType () {
      this.paymentTypeDialog = true
      this.axios.post(`${this.$store.state.API_URL_9010}/financeBill/findBillList`, {
        companyId: this.$store.state.companyId,
        customerId: this.customerId,
        type: this.type
        // customerId: this.info.id
      }).then(res => {
        if (res.data.success) {
          this.auditFunds = res.data.data.auditFunds
          this.newFunds = res.data.data.newFunds
          this.undoFunds = res.data.data.undoFunds
          this.auditFunds.forEach(item => {
            if (item.billItemTemplateList && item.billItemTemplateList.length > 0) {
              for (var i = 0; i < item.billItemTemplateList.length; i++) {
                if (item.billItemTemplateList[i].isModified !== 1) {
                  item.billItemTemplateList[i].unEditable = 'planBill'
                }
              }
            }
            item.selected = false
          })
          this.newFunds.forEach(item => {
            if (item.billItemTemplateList && item.billItemTemplateList.length > 0) {
              for (var i = 0; i < item.billItemTemplateList.length; i++) {
                if (item.billItemTemplateList[i].isModified !== 1) {
                  item.billItemTemplateList[i].unEditable = 'planBill'
                }
              }
            }
            item.selected = false
          })
          this.undoFunds.forEach(item => {
            if (item.isModified !== 1) {
              item.unEditable = 'planBill'
            }
            item.selected = false
          })
        }
      })
    },
    onDelete1 (row) {
      let that = this
      this.tableArray.forEach((data, index) => {
        if (row.uniKey === data.uniKey) {
          that.tableArray.splice(index, 1)
        }
      })
    },
    getAccount () {
      this.axios.post(`${this.$store.state.API_URL_9010}/account/list`, {
        companyId: this.$store.state.companyId
      }).then(res => {
        if (res.data.success) {
          let list = res.data.data
          list.forEach(item => {
            this.axios.post(`${this.$store.state.API_URL_9010}/account/list`, {
              companyId: this.$store.state.companyId,
              parentId: item.id
            }).then(res => {
              if (res.data.success) {
                if (res.data.data.length > 0) {
                  item.children = res.data.data
                }
              }
            })
          })
          this.optionList = list
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select-group__wrap {
    position: relative;
    list-style: none;
    margin: 0;
    padding: 0;
    border-bottom: 1px dashed #e6e6e6;
}
</style>



// WEBPACK FOOTER //
// src/pages/financeManage/comp/AddDetail.vue